import { Injectable } from "@angular/core";
import { CoreSaveService, ConfigService, MessageService } from '@gbs-platform-client/fwk-core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
@Injectable({
  providedIn: 'root'
})
export class DocumentServerService {
  apiEndpoint: string;
  constructor(
    private httpService: HttpClient,
    private configService: ConfigService,
    private _coreSaveService: CoreSaveService,
    private messageService: MessageService,
    // private notification: NotificationsService,
    // private fileUploader: FileUploaderService,
  ) {
    this.apiEndpoint = this.configService.getConfigValue('DocapiEndpoint');
  }
  // static apiUrl = "api/servicep/web/9e9ead45540e/ctrl/T3gMnayuEp3/internal/xml/y8trW/post/2021dEc24/request";
  docAPIUrl = "api/service/web/wre34edfd40e/ctrl/sdfwejkIayuEp3/document/";
  chunkSize = 1048576;

  public getDocumentContent(documentId: string): Promise<any> {
    // httpService.showLoader();
    return new Promise((resolve, reject) => {
      fetch(this.configService.getConfigValue('editorAPIUrl') + this.docAPIUrl + 'get/filecontent/downloaddocument/' + documentId, {
        method: "GET"
      }).then(response => response.blob())
        .then(blob => URL.createObjectURL(blob))
        .then(url => {
          // httpService.hideLoader();
          resolve(url)
        });
    });
  }

  downloadFile = async (file: any): Promise<void> => {
    // async downloadFunction(file:any): Promise<void> {
    const headers = new HttpHeaders();
    //  let documentId=file.Ref_Id
    this.httpService.get(this.apiEndpoint + 'api/service/web/wre34edfd40e/ctrl/sdfwejkIayuEp3/document/downloadFile?documentId=' + file.Ref_Id, { headers, responseType: 'blob' as 'json' }).subscribe( //for SIT
      //for local test uncomment below link
      // this.httpService.get('https://localhost:5002/api/service/web/wre34edfd40e/ctrl/sdfwejkIayuEp3/document/downloadFile?documentId=' + file.Ref_Id ,{headers, responseType: 'blob' as 'json'}).subscribe( 
      // this.httpService.get('https://api/service/web/wre34edfd40e/ctrl/sdfwejkIayuEp3/document/download?documentId=' + file.Ref_Id ,{headers, responseType: 'blob' as 'json'}).subscribe(
      (response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
        if (file.FileName)
          downloadLink.setAttribute('download', file.FileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
      }
    )
  }

}